import React from 'react';
import ArchivingProfileStore from 'stores/ArchivingProfileStore';
import DepartmentFormStore from 'stores/department/DepartmentFormStore';
import ArchivingProfilesPage from './ArchivingProfilesPage';
import AltContainer from 'alt-container';
import DepartmentActions from 'actions/department/DepartmentActions';
import DepartmentFormActions from 'actions/DepartmentFormActions';
import ArchivingProfileActions from 'actions/ArchivingProfileActions';

export default class ArchivingProfilesPageContainer extends React.Component {
  componentDidMount() {
    ArchivingProfileActions.fetchArchivingProfiles();
  }
  render() {
    return (
      <AltContainer
        stores={{ArchivingProfileStore, DepartmentFormStore}}
        actions={{DepartmentActions, DepartmentFormActions}}>
        <ArchivingProfilesPage hasDepartmentContext={!!this.props.params.departmentId} />
      </AltContainer>
    );
  }
}
